"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const moment_1 = __importDefault(require("moment"));
const ZeroView_vue_1 = __importDefault(require("@becrop/components/Common/ZeroView.vue"));
const ParcelShape_vue_1 = __importDefault(require("@becrop/components/Common/ParcelShape.vue"));
const Summary_vue_1 = __importDefault(require("@becrop/components/ReportsComponent/Summary.vue"));
const ReportActions_vue_1 = __importDefault(require("@becrop/components/ReportsComponent/ReportActions.vue"));
const BecropPlus_vue_1 = __importDefault(require("@becrop/components/Common/BecropPlus.vue"));
const BecropVersion_vue_1 = __importDefault(require("@becrop/components/Common/BecropVersion.vue"));
let CardReports = class CardReports extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.noResult = false;
        this.filterArray = [];
        this.format = [20, 20, 20, 25, 30, 30, 10, 10, 20, 0];
    }
    isToday(date) {
        const dateDay = (0, moment_1.default)(date).format('DD');
        const dateMonth = (0, moment_1.default)(date).format('MMM');
        const dateYear = (0, moment_1.default)(date).format('YYYY');
        return [dateDay, dateMonth, dateYear];
    }
    filter() {
        if (!this.Result) {
            return this.samples;
        }
        else {
            this.filterArray = this.samples.filter((item) => {
                item.client_reference.toLowerCase().includes(this.Result.toLowerCase());
            });
            return this.filterArray;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CardReports.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CardReports.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CardReports.prototype, "Result", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CardReports.prototype, "cropActived", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CardReports.prototype, "locale", void 0);
CardReports = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ZeroView: ZeroView_vue_1.default,
            ParcelShape: ParcelShape_vue_1.default,
            Summary: Summary_vue_1.default,
            ReportActions: ReportActions_vue_1.default,
            BecropPlus: BecropPlus_vue_1.default,
            BecropVersion: BecropVersion_vue_1.default,
        },
    })
], CardReports);
exports.default = CardReports;
